<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-my-projects">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="consumer-my-projects--sidebar-col">
      <app-consumer-sidebar></app-consumer-sidebar>
    </div>
    <div class="consumer-my-projects--content flex-1 min-w-0">
      <app-page-header></app-page-header>

      <!-- Loading: checking Compute role -->
      <div *ngIf="accessLevel === 'loading'" class="consumer-my-projects--access consumer-my-projects--access-loading">
        <p>Checking access…</p>
      </div>

      <!-- Full access: Compute in active roles -->
      <ng-container *ngIf="accessLevel === 'full'">
        <app-my-project></app-my-project>
      </ng-container>
    </div>
  </div>
</div>

<!-- Upgrade Your Role modal when Compute access is none or pending -->
<app-modal
  [visible]="showAccessModal"
  header="Upgrade Your Role"
  width="480px"
  [showFooter]="false"
  (visibleChange)="onAccessModalClose()"
>
  <div class="consumer-my-projects--modal-content">
    <div class="consumer-my-projects--modal-body">
      <p *ngIf="accessLevel === 'none'">You need the Compute role to access My Projects. Request the Compute role or contact your administrator.</p>
      <p *ngIf="accessLevel === 'pending'">Your Compute role request is pending <span class="consumer-my-projects--modal-highlight">approval</span>. You will get access to My Projects once it is approved.</p>
      <div class="consumer-my-projects--modal-actions">
        <button
          type="button"
          class="consumer-my-projects--role-upgrade-btn"
          [disabled]="accessLevel === 'pending'"
          (click)="onRoleUpgradeClick()"
        >
          {{ accessLevel === 'pending' ? 'Request Sent' : 'Role Upgrade' }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
